/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { Helmet } from "react-helmet";
import DOMPurify from "dompurify";

import { RelatedJobs, LoadingIndicator } from "components";
import Constants from "app_constants";
import Utils from "utils";
import Theme from "./theme";

const Job = ({ job, relatedJobs, isCompany, history, loaded }) => {
  return (
    <Theme>
      {job.title && (
        <Helmet>
          <meta charSet="utf-8" />
          <title>{`Remote Jobs - ${job.title}`}</title>
        </Helmet>
      )}
      {loaded ? (
        <div className="container">
          {job._id && (
            <div className="columns">
              <div className="column is-9">
                <div className="box">
                  <h1 className="title">{job.title}</h1>
                  <p className="subtitle is-6">
                    {new Date(job.date).toLocaleDateString()}
                    {job.compensation && <span className="divider">|</span>}
                    {job.compensation}
                  </p>
                  <div className="jobInfo">
                    <span className="tag is-info is-small">
                      {Constants.jobCategories[job.category]}
                    </span>
                    <span className="tag is-info is-danger">
                      {Utils.parseJobType(job.type)}
                    </span>
                    {!job.regionalRestrictions ? (
                      <span className="tag is-info is-danger">Worldwide</span>
                    ) : (
                      <p className="regionalRestrictions">
                        Regional Restrictions: {job.regionalRestrictions}
                      </p>
                    )}
                    <div
                      className="description"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(job.description),
                      }}
                    />
                    <br />
                    {!isCompany && (
                      <a
                        href={job.link}
                        target="_blank"
                        className="button is-primary"
                      >
                        Apply to job
                      </a>
                    )}
                  </div>
                </div>
                <RelatedJobs jobs={relatedJobs} />
              </div>
              <div className="column is-3">
                <div className="box company">
                  {job.company.logo && (
                    <figure className="image is-64x64 companyLogo">
                      <a href={job.company.website} target="_blank">
                        <img src={job.company.logo} />
                      </a>
                    </figure>
                  )}
                  {!Utils.validator(job.company.website) ? (
                    <b className="name">{job.company.name}</b>
                  ) : (
                    <a href={job.company.website} target="_blank">
                      <b className="name">{job.company.name}</b>
                    </a>
                  )}
                  {job.company.location && (
                    <p className="info">
                      <i className="fas fa-map-marker-alt textIcon"></i>{" "}
                      {job.company.location}
                    </p>
                  )}
                  {job.company.size && (
                    <p className="info">
                      <i className="fas fa-users textIcon"></i>{" "}
                      {Utils.parseCompanySize(job.company.size)}
                    </p>
                  )}
                  {/* <b className="jobs link" >View All Jobs</b> */}
                </div>
                <div className="contact">
                  <p>
                    <b>Do you want to ask something?</b>
                  </p>
                  <p>or</p>
                  <p>
                    <b>Job is not %100 remote?</b>
                  </p>
                  <button
                    onClick={() => {
                      history.push("/contact");
                      window.scrollTo(0, 0);
                    }}
                    className="button is-info is-rounded"
                  >
                    <span className="icon is-small">
                      <i className="fas fa-envelope"></i>
                    </span>
                    <span>Contact Us</span>
                  </button>
                </div>
                <br />
                {/*

              <AdSense.Google
              client='ca-pub-4172785345322301'
              slot='5587975621'
              style={{ display: 'block' }}
              format='auto'
              responsive='true'
              layoutKey='-gw-1+2a-9x+5c'
              />

              */}
              </div>
            </div>
          )}
        </div>
      ) : (
        <LoadingIndicator />
      )}
    </Theme>
  );
};

export default Job;
